export const SpendSheetPlaceholder = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className="w-full h-[333px] p-4 border border-gray-1 border-dashed rounded-lg flex-col justify-center items-center gap-4 inline-flex">
    <div className="flex flex-col justify-center items-center text-center text-gray+1 text-lg leading-normal">
      <div className="w-[88px] h-[88px] mb-6 bg-gray-2 rounded-full flex justify-center items-center">
        <i className="fa-regular fa-file text-gray+2 text-[32px] text-center" />
      </div>
      {children}
    </div>
  </div>
);
